import {useEffect, useState} from "react";


const hasClipboardAccess = typeof navigator.clipboard?.readText === 'function';

export default function useCanUseClipboard() {
    const [canCopy, setCanCopy] = useState<boolean>(true);
    useEffect(() => {
        navigator.permissions.query({name: 'clipboard-read' as PermissionName}).then(result => {
            setCanCopy(result.state !== 'denied');
        }).catch(() => {
            setCanCopy(true);
        })
    }, []);

    return {hasPermission: canCopy, hasClipboard: hasClipboardAccess}
}
